import React from 'react';
import './folder-content.css';

const WideContentFolder = () => {
  return <></>;
};

export default WideContentFolder;
